import IconEdit from '@assets/icons/edit.svg?react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomGridApi } from '../XTable/types';
import { titleStyles } from './infoStyles';
import useInfoArrays from './hooks/useInfoArrays';
import { InfoArrayRow } from './types';
import RoleChecker from '../RoleChecker';
import { usePage } from '@/contexts/usePageContext';

interface InfoArraysProps {
 id: number;
 apiRef: MutableRefObject<CustomGridApi>;
}

const InfoArrays = ({ id, apiRef }: InfoArraysProps) => {
 const { pageName } = usePage();
 const { t } = useTranslation();
 const apiCurrent = apiRef.current;
 const th = useTheme();
 const { item, loading, sections, tabNames } = useInfoArrays();

 const handleEditClick = (arraySectionIndex: number) => {
  apiCurrent.setModalState({
   id,
   action: 'update',
   tab: 1 + tabNames.length + arraySectionIndex,
  });
 };

 return sections.map((array, index) => (
  <Box sx={{ '&:last-child': { mb: 0 }, mb: 3 }} key={array.Name}>
   <Typography sx={titleStyles}>
    {array.Translation}
    <RoleChecker resource={pageName} action="Update">
     <IconButton onClick={() => handleEditClick(index)}>
      <IconEdit style={{ color: th.palette.kemek.darkestGray }} />
     </IconButton>
    </RoleChecker>
   </Typography>

   {loading.getItem && (
    <Box
     sx={{
      textAlign: 'center',
      p: '12px',
      backgroundColor: th.palette.kemek.lightBlue,
     }}
    >
     <Typography variant="body2" color="text.secondary">
      {t('global.loading')}...
     </Typography>
    </Box>
   )}

   {!loading.getItem && item?.[array.Name]?.length === 0 && (
    <Box
     sx={{
      textAlign: 'center',
      p: '12px',
      backgroundColor: th.palette.kemek.lightBlue,
     }}
    >
     <Typography variant="body2" color="text.secondary">
      {t('global.noItemsFound')}
     </Typography>
    </Box>
   )}

   {!loading.getItem && item?.[array.Name]?.length > 0 && (
    <Box
     sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
     }}
    >
     {array.Data.map((arrItem, key) => (
      <Box
       key={`${array.Name}-${key}`}
       sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        borderRadius: '4px',
        border: `1px solid ${th.palette.kemek.lightestGray}`,
        px: '12px',
        py: 1,
       }}
      >
       {arrItem.map((i: InfoArrayRow) => (
        <Box
         key={i.key}
         sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
         }}
        >
         <Typography sx={{ fontWeight: 'medium', fontSize: 12 }}>
          {i.translation}
         </Typography>
         <Typography
          sx={{ fontSize: 12, textAlign: 'right', wordBreak: 'break-word' }}
         >
          {i.value}
         </Typography>
        </Box>
       ))}
      </Box>
     ))}
    </Box>
   )}
  </Box>
 ));
};

export default InfoArrays;
